import { render, staticRenderFns } from "./ApproveModal.vue?vue&type=template&id=87f0b2c4&scoped=true"
import script from "./ApproveModal.vue?vue&type=script&lang=js"
export * from "./ApproveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f0b2c4",
  null
  
)

export default component.exports